import api from './api';

// Backend endpoint path is /expert/{action} (internal naming); mentor UI wraps
// it here. See project_cwc_mentor_expert_split memory for naming convention.
const mentorPost = (action, params = {}) =>
  api.post(`/expert/${action}`, { action, ...params }).then((res) => res.data);

// Review queue — list of assessments awaiting mentor review.
// Optional: pass mentor_id to also include items already assigned to this mentor.
export const getReviewQueue = (mentorId, limit = 25) =>
  mentorPost('get_review_queue', {
    ...(mentorId ? { expert_id: mentorId } : {}),
    limit,
  });

// Submit a review decision: 'approved' → delivers report to client;
// 'rejected' → sends back to intern for revision.
export const submitReview = ({ assessmentId, mentorId, decision, feedback, categoryFeedback = {} }) =>
  mentorPost('submit_review', {
    assessment_id: assessmentId,
    expert_id: mentorId,
    decision,
    feedback,
    category_feedback: categoryFeedback,
  });

// Mentor stats — reviews completed, approval rate, avg time.
export const getMentorStats = (mentorId) =>
  mentorPost('get_expert_stats', { expert_id: mentorId });

// Fetch full assessment record (including intern responses) for the review pane.
export const getAssessmentForReview = (assessmentId) =>
  mentorPost('get_assessment_for_review', { assessment_id: assessmentId });

// Fetch the template that was used for this assessment so responses can be
// labeled with prompts and help text.
export const getTemplate = (templateId, version) =>
  mentorPost('get_template', { template_id: templateId, version });

// Claim an unclaimed assessment (first-click-wins, 24h SLA starts now).
export const claimAssessment = (assessmentId, mentorId) =>
  mentorPost('claim_assessment', {
    assessment_id: assessmentId,
    expert_id: mentorId,
  });

// Release a claim back to the pool. Optional reason for audit log.
export const releaseAssessment = (assessmentId, mentorId, reason = '') =>
  mentorPost('release_assessment', {
    assessment_id: assessmentId,
    expert_id: mentorId,
    reason,
  });

// Mentor availability profile (per-specialty flags).
export const getMentorProfile = (mentorId) =>
  mentorPost('get_mentor_profile', { expert_id: mentorId });
export const updateMentorProfile = ({ mentorId, acceptingHome, acceptingBusiness }) =>
  mentorPost('update_mentor_profile', {
    expert_id: mentorId,
    accepting_home: acceptingHome,
    accepting_business: acceptingBusiness,
  });
